import React, { useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function BeforeAfter() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-cream py-8 md:py-16 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy text-center mb-8 md:mb-12" data-id="element-3">
          BEFORE AND AFTER
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-6 md:p-8 rounded-lg shadow-lg" data-id="element-5">
            <h3 className="text-xl md:text-2xl font-bold text-charcoal mb-4 md:mb-6 pb-3 md:pb-4 border-b-2 border-gold" data-id="element-6">
              Before this pack:
            </h3>
            <ul className="space-y-3 md:space-y-4 text-base md:text-lg leading-relaxed" data-id="element-7">
              <li className="flex items-start" data-id="element-8">
                <span className="text-navy mr-2 md:mr-3 flex-shrink-0" data-id="element-9">•</span>
                <span data-id="element-10">Sunday evening planning sessions</span>
              </li>
              <li className="flex items-start" data-id="element-11">
                <span className="text-navy mr-2 md:mr-3 flex-shrink-0" data-id="element-12">•</span>
                <span data-id="element-13">Searching for activities that "almost" work</span>
              </li>
              <li className="flex items-start" data-id="element-14">
                <span className="text-navy mr-2 md:mr-3 flex-shrink-0" data-id="element-15">•</span>
                <span data-id="element-16">Walking into Monday stressed</span>
              </li>
              <li className="flex items-start" data-id="element-17">
                <span className="text-navy mr-2 md:mr-3 flex-shrink-0" data-id="element-18">•</span>
                <span data-id="element-19">Teaching the same lessons repeatedly</span>
              </li>
              <li className="flex items-start" data-id="element-20">
                <span className="text-navy mr-2 md:mr-3 flex-shrink-0" data-id="element-21">•</span>
                <span data-id="element-22">Building assessments from scratch</span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 30
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-navy text-white p-6 md:p-8 rounded-lg shadow-lg" data-id="element-23">
            <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 pb-3 md:pb-4 border-b-2 border-gold" data-id="element-24">
              After this pack:
            </h3>
            <ul className="space-y-3 md:space-y-4 text-base md:text-lg leading-relaxed" data-id="element-25">
              <li className="flex items-start" data-id="element-26">
                <span className="text-gold mr-2 md:mr-3 flex-shrink-0" data-id="element-27">✓</span>
                <span data-id="element-28">Lesson plans ready in 20 minutes</span>
              </li>
              <li className="flex items-start" data-id="element-29">
                <span className="text-gold mr-2 md:mr-3 flex-shrink-0" data-id="element-30">✓</span>
                <span data-id="element-31">100+ tested activities organized</span>
              </li>
              <li className="flex items-start" data-id="element-32">
                <span className="text-gold mr-2 md:mr-3 flex-shrink-0" data-id="element-33">✓</span>
                <span data-id="element-34">Monday morning confidence</span>
              </li>
              <li className="flex items-start" data-id="element-35">
                <span className="text-gold mr-2 md:mr-3 flex-shrink-0" data-id="element-36">✓</span>
                <span data-id="element-37">Varied, memorable lessons every week</span>
              </li>
              <li className="flex items-start" data-id="element-38">
                <span className="text-gold mr-2 md:mr-3 flex-shrink-0" data-id="element-39">✓</span>
                <span data-id="element-40">Complete rubrics and tracking ready</span>
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-12 md:mt-16 text-center" data-id="element-41">
          <img src="https://cdn.magicpatterns.com/uploads/vDiKZpXgFqs7a8jq3xATYa/6hoWfCCznAf2Tt4TVKBZS.png" alt="Joyful child wearing headphones, experiencing the love of music" className="w-full max-w-md mx-auto rounded-lg shadow-2xl" data-id="element-42" />
          <p className="text-lg md:text-xl font-semibold text-navy mt-6 italic" data-id="element-43">
            This is what music education should feel like — pure joy.
          </p>
        </motion.div>
      </div>
    </section>;
}